import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=72c053a4&scoped=true&"
import script from "./ErrorList.vue?vue&type=script&lang=js&"
export * from "./ErrorList.vue?vue&type=script&lang=js&"
import style0 from "./ErrorList.vue?vue&type=style&index=0&id=72c053a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c053a4",
  null
  
)

export default component.exports